import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicRealitycheck extends DesigntimeComponent {
    static staticName = "Logic: Realitycheck";
    static staticId = "logicRealitycheck";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            limit: { value: 10, dontTranslate: true }
        };

        this.params = {
            realValue: { key: "url:monthlySpending", value: 0 },
            inputValue: { key: "url:monthlySpending", value: 0 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $("<div class='logicRealitycheck'></div>");
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        if (eventParams.key == this.params.realValue.key)
            this.params.realValue.value = eventParams.value;
        else if (eventParams.key == this.params.inputValue.key)
            this.params.inputValue.value = eventParams.value;
        else
            return;

        var res = 0;
        var realValue = parseFloat(this.params.realValue.value);
        var inputValue = parseFloat(this.params.inputValue.value);

        var diff = 100 * (realValue - inputValue) / realValue;

        if (Math.abs(diff) < parseFloat(this.values.limit.value))
            res = 1; // rougly equal

        else if (realValue > 0) {
            //Du verkar vinna
            if (inputValue > realValue) {
                //mindre än du tror
                res = 2;
            } else {
                //mer än du tror
                res = 3;
            }
        } else {
            //Du verkar förlora
            if (inputValue > realValue) {
                //mer än du tror
                res = 4;
            } else {
                //mindre än du tror
                res = 5;
            }

            //1: RoughlyEqual
            //2:You seem to win more than you think
            //3:You seem to win less than you think
            //4:You seem to lose more than you think
            //5:You seem to lose less than you think
        }

        this.eventBroker.fireValueChanged(this.id, "value", res);
    }

    output = [
        { name: "value", type: "number" }
    ];
}

export { LogicRealitycheck }
